<template>
  <div v-show="isShow" class="canvas-box" ref="canvasBox">
    <canvas
      ref="canvas"
    />
  </div>
</template>
<script>
import fabric from 'fabric'
import diagramBrushInit from '@/utils/fabric/diagramBrush.js'
import { dataURLtoFile } from '@/utils/index'

// 初始化图形笔刷
diagramBrushInit(fabric)

// pad 设计稿的尺寸
const PAD_WIDTH = 1536
const PAD_HEIGHT = 2048
const BASE_LENGTH = Math.max(PAD_WIDTH, PAD_HEIGHT)

const DELETE_ICON = 'data:image/svg+xml,%3C%3Fxml version=\'1.0\' encoding=\'utf-8\'%3F%3E%3C!DOCTYPE svg PUBLIC \'-//W3C//DTD SVG 1.1//EN\' \'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\'%3E%3Csvg version=\'1.1\' id=\'Ebene_1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'595.275px\' height=\'595.275px\' viewBox=\'200 215 230 470\' xml:space=\'preserve\'%3E%3Ccircle style=\'fill:%23F44336;\' cx=\'299.76\' cy=\'439.067\' r=\'218.516\'/%3E%3Cg%3E%3Crect x=\'267.162\' y=\'307.978\' transform=\'matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)\' style=\'fill:white;\' width=\'65.545\' height=\'262.18\'/%3E%3Crect x=\'266.988\' y=\'308.153\' transform=\'matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)\' style=\'fill:white;\' width=\'65.544\' height=\'262.179\'/%3E%3C/g%3E%3C/svg%3E'
// const HANDLE_NAMES = [
//   'handleRight',
//   'handleWrong'
// ]
export default {
  props: {
    imgUrl: String,
    // 笔刷详情
    curBrush: String,
    // 是否显示
    isShow: Boolean,
    pathNum: Number,
    // 画布外框的最大宽度
    maxWidth: Number,
    // 画布外框的最大高度
    maxHeight: Number,
    brushList: Array,
    // 当前图片所在的索引
    index: Number
  },
  data() {
    return {
      originWidth: PAD_WIDTH,
      originHeight: PAD_HEIGHT,
      brushColor: '#ff0000',
      // 物件相对于设计图的基本尺寸（BASE_LENGTH）的缩放比例
      objScale: 1,
      // 当前画布的信息和所有物件
      canvasDataTemp: {},
      fileTemp: null
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler(val) {
        if (val) {
          //
        }
      }
    }
  },
  mounted() {
    // this.maxWidth = window.innerWidth - 495
    // this.maxHeight = window.innerHeight - 115
    // 旋转的角度
    this.angle = 0
    // 笔刷物件
    this.brushObject = null
    // 印章图片物件
    this.sealImg = null
    // 分数物件组合
    this.scoreGroup = null
    // 分数物件
    this.scoreObj = null
    this.initCanvas()
  },
  methods: {
    /**
     * 初始化画布
     */
    initCanvas() {
      const canvas = new fabric.Canvas(this.$refs.canvas, {
        preserveObjectStacking: true,
        isDrawingMode: false,
        backgroundColor: '#f2f7fe'
      })
      // 默认关闭画图模式
      canvas.isDrawingMode = false
      this.canvas = canvas
      fabric.Object.prototype.transparentCorners = false
      fabric.Object.prototype.cornerColor = '#bccbfb'
      fabric.Object.prototype.cornerStyle = 'circle'
      this.setImage()
      this.handleDelbutton()
      // 绑定鼠标事件
      this.bindMouseEvent()

      // this.canvas.on('mouse:down', e => {
      //   if (!this.canvas.getActiveObject() || (this.canvas.getActiveObject() && this.canvas.getActiveObject().lockMovementX)) {
      //     this.panning = true
      //     this.canvas.selection = false
      //   }
      // })

      // this.canvas.on('mouse:up', e => {
      //   if (!this.canvas.getActiveObject() || (this.canvas.getActiveObject() && this.canvas.getActiveObject().lockMovementX)) {
      //     this.panning = false
      //     this.canvas.selection = true
      //   }
      // })
    },
    /**
     * 绑定鼠标事件
     */
    bindMouseEvent() {
      const { canvas } = this
      // 一定要用 before 事件，否者会影响自定义笔刷中的 onMouseDown 事件
      canvas.on('mouse:down:before', o => {
        const isTarget = this.isTarget(o)
        if (isTarget) {
          // 选中物件
          this.$emit('objectSelect', o.target.name)
        }
        // 没有选中的笔刷，则关闭画笔模式
        if (!this.curBrush) {
          canvas.isDrawingMode = false
          return
        }
        if (isTarget) {
          const { target } = o
          // 当前选中的 target
          this.curTarget = target

          // 关闭画图模式
          canvas.isDrawingMode = false
          // 重新渲染
          canvas.requestRenderAll()
        } else {
          // 选中物件之后，第一次点空白区域，不执行画笔
          // TODO 文字输入框，输入完成点击空白区域，也不执行画笔操作
          if (this.curTarget) {
            this.curTarget = null
            return
          }
          this.curTarget = null

          // 开启画图模式
          canvas.isDrawingMode = true
        }
      })
    },
    /**
     * 是否为选中物件
     */
    isTarget({ target }) {
      return target && target.name !== 'bgImage'
    },
    // 添加物件
    addObjects() {
      const { canvas, objScale } = this
      this.brushObject = {}
      this.brushList.forEach(item => {
        const { brushName, getBrush } = item
        if (getBrush) {
          this.brushObject[brushName] = item.getBrush(fabric, canvas, objScale)
        }
      })
    },
    /**
     * 改变笔刷的设置
     */
    changeBrushOpt(curBrush) {
      const { canvas, objScale } = this
      const { brushName } = curBrush
      // 没找到改变的方法，重新初始化笔刷
      this.brushObject[brushName] = curBrush.setBrush(fabric, canvas, curBrush, objScale)
      this.handleBrush(brushName)
    },
    /**
     * 删除物件
     */
    handleDelbutton() {
      const deleteImg = document.createElement('img')
      deleteImg.src = DELETE_ICON
      const _this = this
      function renderIcon(icon) {
        return function renderIcon(ctx, left, top, fabricObject) {
          if (!(_this.canvas.getActiveObject() && _this.canvas.getActiveObject().lockMovementX)) {
            const size = this.cornerSize
            ctx.save()
            ctx.translate(left, top)
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle))
            ctx.drawImage(icon, -size / 2, -size / 2, size, size)
            ctx.restore()
          }
        }
      }
      function deleteObject(eventData, transform) {
        const { target } = transform
        const { canvas } = target
        canvas.remove(target)
        canvas.renderAll()
        _this.objectDelete(target.name)
      }
      // 只要定义 Control 选中的时候就会出现，名称随便命名
      const deleteControl = new fabric.Control({
        x: 0.5,
        y: -0.5,
        offsetY: -16,
        offsetX: 16,
        cursorStyle: 'pointer',
        mouseUpHandler: deleteObject,
        render: renderIcon(deleteImg),
        cornerSize: 24
      })
      fabric.Object.prototype.controls.deleteControl = deleteControl
      // 通过分析源码发现，Textbox 只继承了 9 个点的，如果想增加点，则需求在 Textbox 的 controls 上额外添加
      fabric.Textbox.prototype.controls.deleteControl = deleteControl
    },
    objectDelete(name) {
      // 印章
      if (name === 'sealImg') {
        this.sealImg = null
      }
      // 打分
      if (name === 'ScoreGroup') {
        // 分数物件组合
        this.scoreGroup = null
        // 分数物件
        this.scoreObj = null
      }
      // 删除物件
      this.$emit('objectDelete', name)
    },
    /**
     * 设置图片
     */
    setImage() {
      // TODO 设置成 background 背景图
      fabric.Image.fromURL(
        this.imgUrl,
        oImg => {
          // const { width, height } = this.setCanvasImg(oImg)
          //
          const { width, height } = oImg
          oImg.set({
            name: 'bgImage',
            left: 0,
            top: 0,
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            // 不可以被选中
            selectable: false
          })
          const objScale = Math.max(width, height) / BASE_LENGTH

          this.objScale = objScale
          this.img = oImg
          this.canvas.add(oImg)
          this.canvas.setWidth(width)
          this.canvas.setHeight(height)
          this.originWidth = width
          this.originHeight = height
          this.fitCanvas()
          // 初始化笔刷，添加物件
          this.addObjects(objScale)
        },
        { crossOrigin: 'anonymous' }
      )
    },
    /**
     * 将 canvas 缩放，将图片放到可编辑区域正中间
     */
    fitCanvas() {
      const { maxWidth, maxHeight } = this
      const { width, height } = this.canvas
      const scrollbarWidth = 9
      // 画布需要缩放的值
      let zoom = 1
      // 计算时减去滚动条的宽度
      const realMaxWidth = (maxWidth - scrollbarWidth)
      const realMaxHeight = (maxHeight - scrollbarWidth)
      if (realMaxWidth / realMaxHeight > width / height) {
        zoom = realMaxHeight / height
      } else {
        zoom = realMaxWidth / width
      }

      this.zoomIt(zoom > 1 ? 1 : zoom)
    },
    handleActiveObjectPosition(obj) {
      obj.rotate(this.angle)
      const angleNum = this.angle % 360
      let left = 0
      let top = 0
      // let isResizeObj = false
      switch (angleNum) {
        case 90:
          // isResizeObj = true
          left = obj.height
          break
        case 180:
          left = obj.width
          top = obj.height
          break
        case 270 :
          // isResizeObj = true
          top = obj.width
          break
      }
      obj.set({
        left,
        top
      })
      // 旋转之后，盖章和打分不显示了，需要改变位置
      this.canvas.requestRenderAll()
    },
    /**
     * 操作笔刷
     */
    handleBrush(name) {
      const { canvas } = this
      // 如果有选中，取消选中
      if (canvas.getActiveObject()) {
        this.curTarget = null
        canvas.discardActiveObject()
        canvas.renderAll()
      }
      this.setCurFreeBrush(name)
    },
    /**
     * 设置当前使用的笔刷
     */
    setCurFreeBrush(name) {
      this.canvas.freeDrawingBrush = this.brushObject[name]
    },
    /**
     * 添加印章
     */
    async addSeal(val, isDelete) {
      const { objScale, canvas, sealImg } = this
      const { width: canvasWidth } = canvas
      const zoom = canvas.getZoom()
      if (sealImg && isDelete) {
        // 删除印章
        canvas.remove(sealImg)
      }
      if (!val) {
        // 纯删除
        this.sealImg = null
        canvas.renderAll()
        return
      }
      const img = await this.$resultSealCache.getResultSeal(val)
      const { width } = img
      img.scale(objScale).set({
        name: 'sealImg',
        left: canvasWidth / zoom - (width + 90) * objScale,
        top: 140 * objScale
      })
      if (sealImg) {
        // 移除旧的
        canvas.remove(sealImg)
      }
      // 添加新的
      canvas.add(img)
      this.sealImg = img
      canvas.requestRenderAll()
    },
    /**
     * 打分
     */
    async markScore(scoreVal) {
      const { canvas, objScale, scoreGroup, scoreObj } = this
      const { width: canvasWidth } = canvas
      const zoom = canvas.getZoom()
      // 没有分
      if (!scoreVal) {
        if (scoreGroup) {
          // 如果物件已存在，移除
          canvas.remove(scoreGroup)
          this.scoreGroup = null
          this.scoreObj = null
          canvas.renderAll()
        }
        return
      }
      if (scoreGroup) {
        // 如果打分已创建，只需要更新分数组件
        // text 必须是字符串
        scoreObj.text = `${scoreVal}`
        scoreGroup.addWithUpdate()
        return canvas.renderAll()
      }
      const score = new fabric.Textbox(`${scoreVal}`, {
        fill: '#EC4025',
        fontSize: 200,
        fontFamily: 'Score-Num',
        charSpacing: -40,
        width: 410,
        textAlign: 'center',
        editable: false
      })
      const scoreBottomUrl = await this.$resultSealCache.getResultSeal('scoreBottomUrl')
      scoreBottomUrl.scale(1).set({
        top: 220,
        left: (400 - scoreBottomUrl.width) / 2
      })
      const group = new fabric.Group([score, scoreBottomUrl], {
        name: 'ScoreGroup'
      })
      group.scale(objScale).set({
        left: canvasWidth / zoom - (group.width + 90) * objScale,
        top: 150 * objScale
      })
      this.scoreGroup = group
      this.scoreObj = score
      canvas.add(group)
      canvas.renderAll()
    },
    /**
     * 修改批注
     */
    handleModify() {
      this.canvas.isDrawingMode = false
      // const items = this.canvas.getObjects()
      // this.canvas.setActiveObject(items[0])
    },
    /**
     * 清屏
     */
    confirmClear() {
      // 只留第一个图片 object，其余的物件都删除
      const objects = this.canvas.getObjects()
      objects.shift()
      objects.forEach(item => {
        this.canvas.remove(item)
      })
    },
    /**
     * 放大
     */
    zoomOut() {
      this.zoomIt(1.1)
    },
    /**
     * 缩小
     */
    zoomIn() {
      this.zoomIt(0.9)
    },
    /**
     * 旋转 90 度
     */
    handlexRotate() {
      this.angle += 90
      this.canvas.setActiveObject(this.img)
      const img = this.canvas.getActiveObject()
      const { width, height } = this.canvas

      // const { sealImg } = this
      // sealImg.set({
      //   left: 400,
      //   top: 400
      // })
      this.canvas.setWidth(height)
      this.canvas.setHeight(width)
      this.handleActiveObjectPosition(img)
    },
    zoomIt(factor) {
      const { width, height } = this.canvas
      const zoom = this.canvas.getZoom()
      this.canvas.setWidth(width * factor)
      this.canvas.setHeight(height * factor)
      this.canvas.setZoom(zoom * factor)
    },
    /**
     * 生成 base64 image
     */
    canvasToImg() {
      const { canvas, pathNum } = this
      // 保存画布当前信息
      const oldWidth = canvas.width
      const oldHeight = canvas.height
      const oldZoom = canvas.getZoom()

      // 将画布恢复到初始状态，保存图片的时候需要跟图片原始大小一样
      // this.canvas.setZoom(1)
      // this.zoomIt(1)
      // this.canvas.absolutePan({ x: 0, y: 0 })
      const { originWidth, originHeight } = this

      // 旋转了
      if (this.angle / 90 % 2 !== 0) {
        this.canvas.setWidth(originHeight)
        this.canvas.setHeight(originWidth)
      } else {
        this.canvas.setWidth(originWidth)
        this.canvas.setHeight(originHeight)
      }
      this.canvas.setZoom(1)
      // TODO 如果想优化上传，将 canvas 缩小，图片就会变小，上传速度变快
      const dataURL = this.canvas.toDataURL({
        format: 'jpeg',
        quality: 0.8
      })
      // 将画布还原回原来的状态
      this.canvas.setWidth(oldWidth)
      this.canvas.setHeight(oldHeight)
      this.canvas.setZoom(oldZoom)
      return {
        dataURL,
        pathNum
      }
    },
    getCurTime() {
      return new Date().getTime()
    },
    /**
     * 获取图片 file
     */
    getImgFile(name) {
      const { canvas, imgUrl, pathNum, canvasDataTemp, index, fileTemp } = this
      const objects = canvas.getObjects()
      // 合成图片用时
      const singleCanvasTime = this.getCurTime()
      if (objects.length === 1 && this.angle % 360 === 0) {
        // 只有一张图片，没有再做其他操作，则返回该图片的地址
        return {
          path: imgUrl,
          pathNum,
          index
        }
      }
      const curCanvasData = this.canvas.toJSON(['lockMovementX', 'lockMovementY'])
      this.canvasDataTemp = curCanvasData
      // 批改没有改变
      if (JSON.stringify(canvasDataTemp) === JSON.stringify(curCanvasData) && fileTemp) {
        return {
          pathNum,
          index,
          ...fileTemp
        }
      }
      // 批改改变了，重新生成图片
      const { dataURL } = this.canvasToImg()
      const file = dataURLtoFile(dataURL, name)
      const curFileTemp = {
        file,
        singleCanvasTime: this.getCurTime() - singleCanvasTime
      }
      this.fileTemp = curFileTemp
      return {
        pathNum,
        index,
        ...curFileTemp
      }
    }
  }
}
</script>
<style lang="less" scoped>
.canvas-box {
  display: flex;
  align-items: center;
  justify-content: center;
  // height: calc(100vh - 218px);
  height: 100%;
  position: relative;
  overflow: auto;
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(172, 171, 171, 0.3);
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar {
    width: 9px;
    height: 9px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb{
    background-color: #b1b1b1;
  }
  :deep(.canvas-container) {
    margin: 0 auto;
    // 一定要加这个，否则，垂直居中，放大后滚动条滚动不到最上面
    max-height: 100%;
  }
}
</style>